import { getKeyCodeForEvent, KeyCode } from '../../../utils/key-code';
export const keyDownHandler = (handler, event) => {
    if (handler.isAnimating)
        return;
    const keyCode = getKeyCodeForEvent(event);
    switch (keyCode) {
        case KeyCode.Plus:
            handler.zoomIn();
            break;
        case KeyCode.Minus:
            handler.zoomOut();
            break;
        case KeyCode.LeftArrow:
            handler.panLeft();
            break;
        case KeyCode.UpArrow:
            handler.panUp();
            break;
        case KeyCode.RightArrow:
            handler.panRight();
            break;
        case KeyCode.DownArrow:
            handler.panDown();
            break;
        default:
            return; // No action to be performed
    }
    // Prevent default here to disable touch device double-tap to zoom of browser window
    event.preventDefault();
};
